import React from 'react';
import './Hero.css';
import { Button } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();
  return (
    <section className="hero relative w-full h-screen">
      {/* الخلفية */}
      <video className="background-video absolute top-0 left-0 w-full h-full object-cover" autoPlay loop muted>
        <source src="video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="absolute top-0 left-0 w-full h-full bg-black/50 backdrop-blur-[3px]"></div>

      {/* المحتوى */}
      <div className="relative z-10 pl-2 mt-2 sm:pl-5 md:pl-10 lg:pl-20 sm:mt-6 md:mt-12 lg:mt-24">
        <h5 className="text-sm sm:text-lg md:text-xl text-[#94A3B8] mb-4 sm:mb-6 leading-tight tracking-wide">
          WE ARE CODIFY
        </h5>
        <h1 className="text-3xl sm:text-4xl md:text-5xl text-white font-bold font-poppins mb-4 sm:mb-8 leading-snug sm:leading-tight">
          Custom Product & <br /> Software Development <br />
          Focused On Your Success
        </h1>
        <p className="text-base sm:text-xl md:text-2xl text-white mb-4 sm:mb-6 leading-normal">
          Your success is our priority. Let's build something great together!
        </p>
        <Button
          variant="outlined"
          className="border-2 border-[#96226E] font-poppins text-white text-sm sm:text-lg font-bold px-6 sm:px-8 py-2 sm:py-3 rounded-full hover:bg-[#96226E] hover:text-white transition duration-300"
          onClick={() => navigate("/start-a-project")}
        >
          BOOK A CALL
        </Button>
      </div>
    </section>

  );
};

export default Hero;
